import React from 'react';
import { Button, ButtonProps } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import styled from 'styled-components';
import { COLORS } from '../../utils/constants';

export interface CustomButtonProps extends Omit<ButtonProps, 'size'> {
  variant?: 'outlined' | 'dashed' | 'solid' | 'filled' | 'text' | 'link';
  color?: 'default' | 'primary' | 'danger';
  size?: SizeType;
  isLoading?: boolean;
  isDisabled?: boolean;
  isBlock?: boolean;
  isGhost?: boolean;
  shape?: 'default' | 'circle' | 'round';
  icon?: React.ReactNode;
  iconPosition?: 'start' | 'end';
  htmlType?: 'submit' | 'reset' | 'button';
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  width?: string | number;
  height?: string | number;
  bgColor?: string;
  textColor?: string;
  children?: React.ReactNode;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  type = 'default',
  variant,
  color,
  size = 'middle',
  isLoading = false,
  isDisabled = false,
  isBlock = false,
  isGhost = false,
  shape = 'default',
  icon,
  iconPosition = 'start',
  htmlType = 'button',
  className = '',
  width = 'auto',
  height = '40px',
  bgColor,
  textColor,
  onClick,
  children,
  ...restProps
}) => {
  return (
    <StyledButton
      variant={variant}
      color={color}
      type={type}
      size={size}
      loading={isLoading}
      disabled={isDisabled}
      block={isBlock}
      ghost={isGhost}
      shape={shape}
      icon={icon}
      iconPosition={iconPosition}
      htmlType={htmlType}
      className={className}
      onClick={onClick}
      width={width}
      height={height}
      bgColor={bgColor}
      textColor={textColor}
      {...restProps}
    >
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(Button)<CustomButtonProps>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  color: ${(props) => props.textColor} !important;
  min-width: 156px;
  background-color: ${(props) =>
    props.disabled ? COLORS.grey.light : props.bgColor} !important;
  border-radius: 8px;
`;

export default CustomButton;
